/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ERROR_CODES = {
    SCHEDULE_IS_NOT_AVAILABLE: 'battle_schedule_is_not_available',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
}

export default {
    [ERROR_CODES.SCHEDULE_IS_NOT_AVAILABLE]: {
        title: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_is_not_available.title'
                defaultMessage='Список боев недоступен'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_is_not_available.description'
                defaultMessage='Попробуйте зайти на страницу позже'
            />
        ),
    },
    [ERROR_CODES.UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_data_loading_error.title'
                defaultMessage='Не удалось отобразить список боёв'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_data_loading_error.description'
                defaultMessage='Список боёв временно недоступен. Попробуйте позже.'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./containers/WGCWXBattleSchedule/errors.js